import { createContext, useContext } from 'react';

/**
 * Site-wide modal triggers — spec §7.20, §25.5. The contact and membership modals are opened
 * from chrome that lives outside any page: the footer's "Contact Us" pill and the header's
 * "Become A Member" pill. A context keeps the modal state in SiteLayout (one instance, mounted
 * once) instead of duplicating a copy inside both header and footer.
 */
export type SiteModal = 'contact' | 'membership' | null;

export type ModalsApi = {
  open: (modal: Exclude<SiteModal, null>) => void;
  close: () => void;
};

export const ModalsContext = createContext<ModalsApi>({ open: () => {}, close: () => {} });

export function useModals(): ModalsApi {
  return useContext(ModalsContext);
}
